const helpers = require('./src/helpers')
module.exports = helpers.colorVariable
